import { useState } from "react";

import * as Api from "@/api";
import Avatar from "@/design/components/Avatar";
import Valkyrie, { viSpinnerThird, viTrashCan } from "@sippy-platform/valkyrie";

import { Card, IconButton, List, ListItem, ListItemAvatar, ListItemText } from "@mui/material";
import PropTypes from "prop-types";

function HandsetItem({ provisioning, provisioningDispatch, account, setAvailableUsers }) {
  const [pending, setPending] = useState();

  function handleRemoveAccount() {
    setPending(true);

    Promise.resolve(Api.deleteProvisioningAccount(provisioning, account))
      .then(() => provisioningDispatch({ type: "removeHandset", id: account.id }))
      .then(() => {
        Promise.resolve(Api.getProvisioningUsers()).then((response) => {
          setAvailableUsers(response.data.sippeers);
        });
      })
      .finally(() => setPending(false));
  }

  return (
    <Card variant="outlined">
      <List>
        <ListItem
          id={`handset-${account.handset}`}
          secondaryAction={
            <IconButton color="inherit" onClick={() => handleRemoveAccount(account.id)} disabled={pending}>
              <Valkyrie icon={pending ? viSpinnerThird : viTrashCan} spin={pending} />
            </IconButton>
          }
        >
          <ListItemAvatar>
            <Avatar text={account.username} />
          </ListItemAvatar>
          <ListItemText primary={account.username} secondary={`Handset ${account.handset}`} />
        </ListItem>
      </List>
    </Card>
  );
}

HandsetItem.propTypes = {
  provisioning: PropTypes.object,
  account: PropTypes.object,
  setAvailableUsers: PropTypes.func,
  provisioningDispatch: PropTypes.func,
};

export default HandsetItem;
